import React, { useState, useEffect } from "react";
import { getCollections } from "services/storefront/common";
import Link from "helpers/link";
import { ReactComponent as CopyURL } from "assets/svgs/copy-url.svg";
import Spinner from "components/spinner";

const ProductCreator = ({ data }) => {
    const [collections, setCollections] = useState({
        data: [], selected: { name: null, value: null }, versionInput: "", 
    });
    const [url, setUrl] = useState("");

    const fetchCollections = async () => {
        const shopifyCollections = await getCollections(data.collectionItems.map((item) => item.handle));
        const dataArray = Object.values(shopifyCollections.data || {});

        const dataObject = dataArray.reduce((acc, item, index) => {
            const key = item.handle;
            acc[key] = {
                ...item,
                title: data.collectionItems[index].title,
                url: data.collectionItems[index].url, 
            }; 
            return acc;
        }, {});

        setCollections((prevState) => ({
            ...prevState,
            data: dataObject,
            selected: {
                name: shopifyCollections.data.collection0.handle,
                value: shopifyCollections.data.collection0.products.edges[0].node.handle, 
            }, 
        }));
    };

    const handleCollectionChange = (event) => {
        const { name, value } = event.target;

        if (name === "store") {
            return setCollections((prevState) => ({
                ...prevState,
                selected: { name: value, value: collections.data[value].products.edges[0].node.handle }, 
            })); 
        }
        if (name === "product") {
            return setCollections((prevState) => ({
                ...prevState,
                selected: { ...prevState.selected, value }, 
            })); 
        }

        return setCollections(((prevState) => ({ ...prevState, versionInput: value })));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
    
        if (collections.data[collections.selected.name].url === "/") {
            const versionInputWithDash = collections.versionInput.replace(/ /g, '-');
            const storeUrl = `${window.location.origin}/products/${collections.selected.value}?version_${versionInputWithDash}`;
            return setUrl(storeUrl);
        }
    
        const versionInputWithDash = collections.versionInput.replace(/ /g, '-');
        return setUrl(`${collections.data[collections.selected.name].url}/products/${collections.selected.value}?version_${versionInputWithDash}`);
    };
    

    useEffect(() => {
        fetchCollections();
    }, []);

    if (collections.data.length === 0) return <Spinner />;
    
    return (
        <div>
            <h2 className="text-center text-blue-700 mb-8"> Quick Product Creator </h2>
            <form
                onSubmit={handleSubmit}
                onChange={handleCollectionChange}
                className="max-w-[500px] mx-auto"
            >
                <label className="flex flex-col form-label" htmlFor="store">
                    Store 
                    <select className="form-input" name="store">
                        {Object.values(collections?.data || {})?.map((collection) => (
                            <option key={collection.handle} value={collection.handle}>
                                {collection.title}
                            </option>
                        ))}
                    </select>
                </label>
                <label className="flex flex-col form-label" htmlFor="product">
                    Product 
                    <select
                        defaultValue={collections?.selected?.value}
                        name="product"
                        className="form-input"
                    >
                        {collections?.data[collections?.selected?.name]?.products?.edges.map((product) => (
                            <option
                                key={product.node.handle}
                                value={product.node.handle}
                            >
                                {product.node.metafield?.value ? product.node.metafield?.value : product.node.title}
                            </option>
                        ))}    
                    </select>
                </label>
                <label className="flex flex-col form-label" htmlFor="product">
                    Version
                    <input
                        name="versionInput"
                        className="form-input w-full"
                        type="text"
                        defaultValue={collections?.versionInput}
                        required
                    />
                </label>
                <button className="btn-primary w-1/5 font-normal" type="submit">
                    Create
                </button>
                {url && (
                    <div className="mt-4 flex flex-col">
                        <Link className="text-gray-601 mb-4 tracking-wider" to={url}> 
                            {url}
                        </Link>
                        <button
                            type="button"
                            className="flex items-center gap-2 text-blue-700 font-light"
                            onClick={() => navigator.clipboard.writeText(url)}
                        >
                            <CopyURL className="w-5 h-5" />
                            Copy Above URL
                        </button>
                    </div>
                )}
            </form>
            
        </div>
    );
};

export default ProductCreator;
